import React from "react";
import { Typography, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import { CloudUpload } from "@material-ui/icons";

export default function CreateDataProjectModal({
    newDataProjectDetails,
    setNewDataProjectDetails,
    createDataProjectModal,
    handleCreateDataProjectModalClose,
    handleCreateDataProject,
}) {

    // setCurrentDialog("Create Lab");
    const [currentDialog, setCurrentDialog] = React.useState("Create Synthetic Data");
    const [loading, setLoading] = React.useState({ loading: false, message: "" })

    const renderDialogContent = () => {
        switch (currentDialog) {
            case "Create Synthetic Data":
                return (
                    <div>
                        <Typography
                            variant="h5"
                            style={{
                                marginBottom: "10px",
                            }}
                        >
                            Enter the Project details:
                        </Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Project Name"
                            type="text"
                            fullWidth
                            required
                            value={newDataProjectDetails.name}
                            onChange={(event) => setNewDataProjectDetails({ ...newDataProjectDetails, name: event.target.value })}
                        />
                        <TextField
                            margin="dense"
                            id="brief"
                            label="Brief Description"
                            type="text"
                            fullWidth
                            multiline
                            required
                            rows={3}
                            value={newDataProjectDetails.description}
                            onChange={(event) => setNewDataProjectDetails({ ...newDataProjectDetails, description: event.target.value })}
                        />
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div>
            <Dialog
                open={createDataProjectModal}
                onClose={handleCreateDataProjectModalClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ fontSize: "30px" }}>Create New Synthetic Data Project</div>
                </DialogTitle>
                <DialogContent>{renderDialogContent()}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCreateDataProjectModalClose}
                        color="quCreateColor"
                        disabled={loading.loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleCreateDataProject}
                        disabled={loading.loading}
                        color="quCreateColor"
                    >
                        {currentDialog === "Create Synthetic Data" ? "Submit" : "Next"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}
